import React from 'react';
import {
  EntityKindPicker,
  EntityProcessingStatusPicker,
  UserListPicker,
} from '@backstage/plugin-catalog-react';
import {
  FacetedEntityLifecyclePicker,
  FacetedEntityNamespacePicker,
  FacetedEntityOwnerPicker,
  FacetedEntityTagPicker,
  FacetedEntityTypePicker,
} from './index';

export const GroupsIndexFilters = () => (
  <>
    <EntityKindPicker initialFilter="group" hidden />
    <FacetedEntityTypePicker />
    <UserListPicker initialFilter="all" />
    <FacetedEntityOwnerPicker />
    <FacetedEntityLifecyclePicker />
    <FacetedEntityTagPicker />
    <EntityProcessingStatusPicker />
    <FacetedEntityNamespacePicker />
  </>
);
